const VehicleDetail = {
  init: function (element) {
    const _ = this
    const printButton = element.querySelector('.print-css')
    const vehicleImage = element.querySelector('.vehicle-detail__left-column > div')
    const vehicleDescription = element.querySelector('.vehicle-detail__right-column')
    const vehicleDisclaimer = element.querySelector('.vehicle-detail__disclaimer')
    const vehicleHeader = element.querySelector('.vehicle-detail__header')

    if(printButton && vehicleImage && vehicleDescription && vehicleDisclaimer && vehicleHeader){
        printButton.addEventListener ("click", (e) => {
            this.appendPrint(vehicleHeader ,vehicleDisclaimer, vehicleImage, vehicleDescription)
        })
    }
    else {
      alert('An error occurred while trying to print this page.')
    }
  },
  appendPrint: (header, disclaimer, image, description) => {
    const disclaimerClone = disclaimer.cloneNode(true)
    const descriptionClone = description.cloneNode(true)
    // if(header.querySelector('.printable')){} else{
    //     disclaimerClone.classList.add('printable')
    //     header.append(disclaimerClone)
    // }
    if(image.querySelector('.printable')){} else{
        descriptionClone.classList.add('printable')
        image.append(descriptionClone)
    }
    window.print()
    return false
  }
}

export default VehicleDetail
